import React from "react";
export default function PhysicalSecurity({ data }) {
  return (
    <>
      <section className="physical-security-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-10">
              <div className="physical-security-content">
                <h2 className="heading">{data?.head}</h2>
                <p dangerouslySetInnerHTML={{ __html: data?.desc }} />
              </div>
            </div>
          </div>

          <div className="row"> {
              data?.boxes?.map((item, index) => (
                <div key={index} className="col-lg-3 col-md-3">
                  <div className="physical-security-box">
                    <img src={item?.img} alt="Physical Security Image" />
                    <span>{item?.label}</span>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </section>
    </>
  )
}